export default __webpack_public_path__ + "custom-slider-icon.7bf89b0a.svg";